<template>
  <div>
    <shipblu-prompt
      class="shipment-modal"
      @close="closeModal"
      :active.sync="addUserModal"
      :title="`${$t('Add Vendor Agent')}`"
      :buttons-hidden="true">
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input v-validate="'required|alpha_spaces'" :label-placeholder="$t('Name')" name="name" v-model="data.name" class="mt-10 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input v-validate="{ required: true, regex: /(^01[0,1,2,5]\d{8}$|^\u0660\u0661[\u0660,\u0661,\u0662,\u0665][\u0660-\u0669]{8}$)/ }" name="Phone Nmber" :label-placeholder="$t('Phone Number')" v-model="data.phone_number" class="mt-10 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('Phone Nmber')">{{ errors.first('Phone Nmber') }}</span>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-4 mt-4">
          <button @click="closeModal" class="btn disable-btn">{{ $t('Cancel') }}</button>
          <button @click="addUser" class="active-btn btn">{{ $t('Add') }}</button>
        </div>
    </shipblu-prompt>
  </div>
</template>

<script>
import ShipbluPrompt from '../../../layouts/components/ShipBluPrompt.vue'
import {sendRequest} from '../../../http/axios/requestHelper.js'
import vSelect from 'vue-select'
import i18nData from '../../../i18n/i18nData.js'

export default {
  props: ['addUserModal', 'data'],
  data () {
    return {
      apiURL: 'api/v1/users/vendor-agents/',
      editMode: true,
      user: {
        first_name: '',
        last_name: '',
        phone_number: ''
      }
    }
  },
  watch: {
    addUserModal () {
      this.user = Object.assign({}, this.data)
    }
  },
  methods: {
    addUser () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.isOnline) this.$emit('addUserModal', false)
          sendRequest(false, false, this, this.apiURL, 'post', this.data, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['User'] + i18nData[this.$i18n.locale][' has been created successfully!'],
                position: 'top-center'
              })
              this.$emit('addUserModal', false)
              this.$emit('loadData')
            }
          )
        }
      })
    },
    closeModal () {
      this.$emit('addUserModal', false)
      this.$emit('loadData')
    }
  },
  components: {
    ShipbluPrompt,
    vSelect
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss"
</style>